import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_APPLICATION_BY_ID } from './get-application-by-id.hook';
import { GET_EAU_APPLICATIONS } from './get-applications.hook';

export const CREATE_EAU_APPLICATIONS = gql`
  mutation createEauApplication($payload: CreateEauApplicationInput!) {
    createEauApplication(payload: $payload) {
      _id
      companyId
    }
  }
`;

export const useCreateEauApplication = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('applications');
  const [createEauApplication, { loading }] = useMutation(CREATE_EAU_APPLICATIONS, {
    onCompleted: data => {
      if (data?.createEauApplication?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('eAU.notifications.created'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [GET_APPLICATION_BY_ID, GET_EAU_APPLICATIONS],
  });
  return { createEauApplication, loading };
};
